import { SignInAPI } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

interface DemoTrialTokenResponse extends ResponseBase {
  data: {
    token: string;
  };
}

/**
 * 데모 체험용 토큰 생성
 * 클라이언트 IP 기반으로 데모 회사를 할당하고 DEMO_TRIAL 토큰을 생성합니다.
 */
export function createDemoTrialToken() {
  return SignInAPI.post<DemoTrialTokenResponse>('/api/v1/demo-trial/token');
}
